import { gql } from "@apollo/client";


export const FETCH_CONTEXT_FOR_MESSAGE = gql`
    query contextForMessage($messageId: ID!) {
        contextForMessage(messageId: $messageId) {
            id
            createdAt
            updatedAt
            isLocked
            
            graphEnabled
            companyContextEnabled
            
            contentNodes {
                id
                type
                text
                metadata
                associatedOfficialDocument {
                    id
                    reference
                    category
                    hoverTitle
                    metadata
                }
                childNodes {
                    id
                    type
                    metadata
                }
            }
            
            attachments {
                id
                fileName
                tokens
                fileSize
            }
        }
    }
`;